import React, { useState, memo } from "react";
import { message, Icon, Spin, Button, Modal, Form, Input } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { delay } from "redux-saga/effects";
import { useHistory } from "react-router-dom";
import Type from "@actionTypes";
import Vcode from './Vcode'
import bg from "../../images/login-bg@2x.png";
import "./index.less";

const LoginForm = ({ login }) => {
  const [form] = Form.useForm();

  const onFinish = async () => {
    await form.validateFields();
    const params = form.getFieldsValue();
    login(params);
  };

  const keyDownLogin = (e) => {
      if (e.keyCode && e.keyCode === 13) {
          onFinish()
      }
  }
  return (
    <>
      <div className="system-title">数字调解平台</div>
      <Form
        form={form}
        size="large"
        onFinish={onFinish}
        style={{ marginLeft: 70 }}
      >
        <Form.Item
          name="username"
          label="账号"
          required={false}
          rules={[{ required: true, message: "请输入账号!" }]}
        >
          <Input placeholder="请输入账号" className="login-input" />
        </Form.Item>
        <Form.Item
          label="密码"
          name="password"
          required={false}
          rules={[{ required: true, message: "请输入密码!" }]}
        >
          <Input.Password onKeyDown={keyDownLogin} placeholder="请输入密码" className="login-input" visibilityToggle={false}/>
        </Form.Item>
        <Form.Item>
          <Button type="primary" size="large" htmlType="submit">
            登录
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

const Login = () => {
  const [visible, setVisible] = useState(false);
  const [phone, setPhone] = useState('')
  const [account, setAccount] = useState({})
  const [vcode, setVcode] = useState({})
  const dispatch = useDispatch();
  const history = useHistory();

  const login = (params) => {
    setAccount(params)
    dispatch({
      type: Type.LOGIN_REQUEST,
      params,
      cb: handleLoginSuccess,
    });
  };

  const verCode = () => {
    dispatch({
        type: Type.GET_VCODE,
        params: { username: account.username, vCode: vcode },
        cb: handleLoginSuccess
    })
  }

  const handleLoginSuccess = (status, phone = "") => {
    if (status === 2) {
      history.replace("/fagicCourt");
    } else if (status === 0) {
      message.info("初次登录请修改密码");
      delay(1000);
      history.push("/editPassword");
    } else if (status === 1) {
      message.warning("账户冻结");
    } else if (status === 5) {
      setVisible(true)
      setPhone(phone)
    }
  };


  return (
    <div className="login">
      {/* <Spin
        className="login-pane"
        spinning={!!this.props.loading.status}
        indicator={antIcon}
        size="large"
      /> */}
      <div className="bg">
        <img src={bg} alt="" />
        <div className="title">
          <span>欢迎使用数字调解平台</span>
          <span>Welcome to Digital Mediation Platform</span>
        </div>
      </div>

      <div className="login-form">
        <LoginForm login={login} />
      </div>
      <div className="login-footer">
        <a href="https://beian.miit.gov.cn">苏ICP备19055267号-3</a>
        <font>© 2020 江苏铭博信息技术有限公司 版权所有</font>
      </div>
      <Modal
        title="验证"
        destroyOnClose={true}
        visible={visible}
        onOk={verCode}
        onCancel={() => setVisible(false)}
        okText="确定"
        cancelText="取消"
      >
        <Vcode
          setVcode={setVcode}
          phone={phone}
          sendAgain={() => {
            login(account);
          }}
        />
      </Modal>
    </div>
  );
};

export default memo(Login);
